import { config } from '@rematter/config';
import { BillStatus, enumBillStatus } from '@rematter/frontend-lib-api-client';
import { maybe } from '@rematter/ui-web';

import { billListQueryAtom } from '../_graphql/queryBillList';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchParam = atomFromQueryString.string('q');
export const $billStatusFilter =
  atomFromQueryString.string<BillStatus>('status');

export const $limit = atomFromQueryString.number('limit', config.pageSize);
export const $offset = atomFromQueryString.number('offset', 0);

// 🟢🟢🟢 REMOTE DATA
export const $remoteBills = billListQueryAtom((get) => {
  const statusFilter = get($billStatusFilter);
  const searchParam = get($searchParam);

  return {
    variables: {
      searchTerm: searchParam,
      status: statusFilter
        ? [statusFilter]
        : [enumBillStatus.Pending, enumBillStatus.Paid, enumBillStatus.Voided],
      pagination: maybe(get($limit), (limit) => ({
        limit,
        offset: get($offset),
      })),
    },
  };
});
